<template>
  <div class="container">
    <div class="row">
      <div class="col-md-4 offset-md-4">
        <h2 class="text-center">Sign In</h2>
        <h5 class="text-center">
          <router-link to="/sign-up">
            Need an account?
          </router-link>
        </h5>
        <p v-if="$route.query.redirect" class="error text-center">
          You need to sign in first.
        </p>
        <p v-if="error" class="error">
          {{ error }}
        </p>
        <form @submit.prevent="signIn" autocomplete="off">
          <b-field label="Email">
              <b-input 
                v-model.trim="email"
                placeholder="Email Address"
                type="email"
                maxlength="30">
              </b-input>
          </b-field>
          <b-field label="Password">
                <b-input 
                  v-model.trim="password"
                  placeholder="Password (Min 8 characters)"
                  type="password"
                  minlength="8"
                  password-reveal>
                </b-input>
            </b-field>
          <button type="submit" class="btn btn-info btn-block">
            Sign In
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      password: "",
      error: ""
    };
  },
  methods: {
    signIn() {
      this.$store
        .dispatch("signIn", {
          email: this.email,
          password: this.password
        })
        .then(() => {
          this.$toasted.show("Welcome Back")
          this.$router.replace(this.$route.query.redirect || "/");
        })
        .catch(error => {
          this.error = error;
        });
    }
  }
};
</script>

<style scoped lang="scss">
form {
  margin-top: 1rem;
}
.error {
  text-align: center;
}
</style>
